import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Button from "components/Shared/CustomButtons/Button.js";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import Table from "components/Recycler/Collectables/ArchivedBatches";

import { useDispatch, useSelector } from "react-redux";
import { getArchivedCollectedRecycler } from "store/actions/recycler";

const CollectedBatchesRecycler = () => {
  const dispatch = useDispatch();
  const { archivedCollected } = useSelector((state) => state.recycler);
  const [page, setPage] = useState(
    archivedCollected ? archivedCollected.pag.page : 1
  );
  const [amount, setAmount] = useState(
    archivedCollected ? archivedCollected.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    archivedCollected ? archivedCollected.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    archivedCollected ? archivedCollected.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    archivedCollected ? archivedCollected.pag.search_by : "branch_name"
  );

  const history = useHistory();

  useEffect(() => {
    dispatch(
      getArchivedCollectedRecycler(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, dispatch]);

  const showBatchHandler = (id) => {
    history.push("/admin/recycler/batch-items/" + id);
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Collected Archived Batches</h4>
        </CardHeader>
        <CardBody>
          {archivedCollected && (
            <div>
              <Table
                rows={archivedCollected.data}
                totalRows={archivedCollected.pag.total}
                rowsPerPage={amount}
                setRowsPerPage={setAmount}
                order={orderType}
                setOrder={setOrderType}
                orderBy={orderField}
                setOrderBy={setOrderField}
                page={page - 1}
                setPage={setPage}
                showBatch={showBatchHandler}
                searchHandler={setSearchValue}
                searchValue={searchValue}
                selectedSearchBy={searchBy}
                handleSearchByChange={setSearchBy}
                isCollected={true}
              />
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default CollectedBatchesRecycler;
